import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tabs, Layout, Typography, Input, Button, Tooltip } from 'antd';
import { organizationActions, periodsActions } from '../../redux/actions/';
import Localization from '../../utils/localization';
import RenderLoader from '../../components/RenderLoader';
import GlobalSettings from './GlobalSettings';
import Currency from './Currency';
import PeriodManagement from './PeriodManagement';
const { TabPane } = Tabs;

const Settings = () => {
    const dispatch = useDispatch();
    const organization = useSelector((state) => state.organization.organization);
    const [activeKey, setActiveKey] = useState('1');

    useEffect(() => {
        dispatch(organizationActions.getOrganization());
    }, [dispatch]);

    const onChange = (newActiveKey) => {
        setActiveKey(newActiveKey);
    };

    const onEdit = (targetKey, action) => {
        if (action === 'add') {
            //handleCreateCustomTab();
        } else {
            //handleRemoveCustomTab(targetKey);
        }
    };

    const renderContent = () => {
        return (
            <Layout style={{ height: '100vh', marginTop: '0px' }}>
            <Tabs onChange={onChange} activeKey={activeKey} type="card" destroyInactiveTabPane>
                <TabPane closable={false} tab={Localization.settings.globalSettings} key="1">
                    <GlobalSettings/>
                </TabPane>
                <TabPane closable={false} tab={Localization.settings.currency} key="2">
                    <Currency/>
                </TabPane>
                <TabPane closable={false} tab={Localization.settings.periodManagement} key="3">
                    <PeriodManagement/>
                </TabPane>
            </Tabs>
            </Layout>
        );
    };
    return renderContent();
};
export default Settings;
